import type { IconName, IconSize } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";
import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";

import type { Filter } from "../NotificationContext";
import { useNotificationContext, FILTERS } from "../NotificationContext";

export const NotificationFilter = ({
  iconSize = "md",
}: {
  iconSize?: IconSize;
}) => {
  const { activeFilter, setActiveFilter } = useNotificationContext();
  const queryClient = useQueryClient();

  const handleSelect = (filter: Filter) => {
    void queryClient.invalidateQueries({ queryKey: ["notifications", filter] });
    setActiveFilter(filter);
  };

  const radioItems: Array<{ value: Filter; label: string; icon: IconName }> = [
    {
      value: FILTERS.ALL,
      label: t("header_v3.filters.all"),
      icon: "bullet-list",
    },
    {
      value: FILTERS.UNREAD,
      label: t("header_v3.filters.unread"),
      icon: "app",
    },
    {
      value: FILTERS.ARCHIVED,
      label: t("header_v3.filters.archived"),
      icon: "inbox-empty",
    },
  ];

  return (
    <Menu
      align="end"
      side="bottom"
      options={[
        {
          type: "radio-group",
          value: activeFilter,
          items: radioItems.map(({ value, label, icon }) => ({
            type: "radio",
            value,
            label,
            icon,
            onClick: () => handleSelect(value),
          })),
        },
      ]}
      trigger={
        <IconButton
          icon="filter"
          aria-label={t("header_v3.filters.title")}
          size={iconSize}
          variant="ghost"
        />
      }
    />
  );
};
